import React, { useEffect, useState } from 'react';

import { algoliaSortOptions } from '@/constants/used-cars/used-cars.constants';
import { SortOption } from '@/types/used-cars/used-cars.types';

import { SearchResultSelect } from '../search-result-select/search-result-select';
import { SearchResultsActionWrapper } from '../search-results-action-wrapper/search-results-action-wrapper';

import { SortOptions } from './components/sort-options/sort-options';

export const SortSelect: React.FC<{
  onSortChange: (option: SortOption) => void;
  overlayClassName?: string;
  current?: string;
}> = ({ onSortChange, overlayClassName = '', current }) => {
  const [isVisible, setIsVisible] = useState(false);

  // Close dropdown when URL sort changes
  useEffect(() => {
    setIsVisible(false);
  }, [current]);

  const currentLabel = algoliaSortOptions.find(
    (option) => option.value === current,
  );

  return (
    <SearchResultsActionWrapper label="">
      <SearchResultSelect
        content={
          <SortOptions
            setSorting={onSortChange}
            options={algoliaSortOptions}
            sorting={currentLabel}
          />
        }
        isVisible={isVisible}
        setIsVisible={setIsVisible}
        overlayClassName={overlayClassName}
      >
        Sort By
      </SearchResultSelect>
    </SearchResultsActionWrapper>
  );
};
